import { useState } from 'react';
import { ModalState } from '@sdk/components/ui/modal/useModalState';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import ConfirmModal from '@sdk/components/ui/confirmModal/ConfirmModal';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Checkbox from '@sdk/components/forms/Checkbox';

import AnnouncementRed from '@web/assets/svg/Icons/32/announcement-red.svg';

import { CheckboxContainer, CheckboxLabel } from './conversationDeleteModal.styles';
import { useDeleteConversationModal } from './conversationDeleteModal.hooks';

type Props = {
  modalState: ModalState;
};

export const ConversationDeleteModal = ({ modalState }: Props) => {
  const [isConversationDeleteAccepted, setIsConversationDeleteAccepted] = useState(false);
  const { deleteTexts, onSubmit } = useDeleteConversationModal();

  return modalState.isVisible ? (
    <ConfirmModal
      fullScreen
      titleText={gettext('Delete conversation')}
      titleIcon={<AnnouncementRed />}
      titleThemeColor={ThemeColorType.danger}
      primaryButtonText={gettext('Delete')}
      primaryButtonType={ButtonType.danger}
      secondaryButtonText={gettext('Cancel')}
      onPrimaryClick={onSubmit}
      dismiss={modalState.close}
      primaryButtonDisabled={!isConversationDeleteAccepted}
      buttonsPadding={0}>
      <>
        <Text14 themeColor={ThemeColorType.gray}>{deleteTexts.description}</Text14>
        <CheckboxContainer isActive={isConversationDeleteAccepted}>
          <Checkbox
            value={isConversationDeleteAccepted}
            onChange={setIsConversationDeleteAccepted}
          />
          <CheckboxLabel
            themeColor={ThemeColorType.gray}
            onClick={() => {
              setIsConversationDeleteAccepted((v) => !v);
            }}>
            {deleteTexts.deletingConfirmationLabel}
          </CheckboxLabel>
        </CheckboxContainer>
        <Text14 semiBold themeColor={ThemeColorType.danger}>
          {deleteTexts.confirmationWarning}
        </Text14>
      </>
    </ConfirmModal>
  ) : null;
};
